/** Azure regions the wizard offers, by display name. The display name is what a deployment request carries as azure_region. */
export const AZURE_REGIONS = [
  'East US', 'East US 2', 'Central US', 'North Central US', 'West US', 'West US 2',
  'North Europe', 'West Europe', 'UK South',
  'Canada Central', 'Canada East',
  'Southeast Asia', 'Australia East', 'Japan East', 'Brazil South',
]

/** Display name -> Azure location code. These match the backend's location map, so a region id is also a valid location. */
export const AZURE_REGION_CODES: Record<string, string> = {
  'East US': 'eastus',
  'East US 2': 'eastus2',
  'Central US': 'centralus',
  'North Central US': 'northcentralus',
  'South Central US': 'southcentralus',
  'West US': 'westus',
  'West US 2': 'westus2',
  'North Europe': 'northeurope',
  'West Europe': 'westeurope',
  'UK South': 'uksouth',
  'Canada Central': 'canadacentral',
  'Canada East': 'canadaeast',
  'Southeast Asia': 'southeastasia',
  'Australia East': 'australiaeast',
  'Japan East': 'japaneast',
  'Brazil South': 'brazilsouth',
}
